import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { useBoardWorklogs } from "../../../../../reactQuery/boards";
import { setDateRange, setWorkHours } from "../../../../../redux/SearchSlice";
import { getLastSevenDays } from "../../../../../utils";
import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import useBoardIdByKey from "../../../../../hooks/useBoardIdByKey";
import { getResponseData } from "../../../../../reactQuery/response";

export function useBoardWorklogState() {
  const [byTask, setByTask] = useState(false);
  const { id } = useBoardIdByKey();
  const dispatch = useDispatch();
  const dateRange = useSelector((state) => state.search.dateRange);
  const [selectedUserSearch, updateSearchParams] =
    useCustomSearchParams("search");
  const [cardData] = useCustomSearchParams("card_id");
  const [milestone] = useCustomSearchParams("milestone");
  const [searchParams] = useSearchParams();
  const selectedUsers = selectedUserSearch?.split(",") || [];

  const { boardWorklog, isLoading } = useBoardWorklogs({
    dateRange,
    id: [id],
    milestone: milestone ? [milestone] : [],
    user: selectedUsers.map((userId) => ({ user_id: userId })),
  });

  const worklogs = useMemo(() => getResponseData(boardWorklog, []), [boardWorklog]);
  const totalWorkHours = useMemo(
    () =>
      worklogs.reduce(
        (accumulator, currentValue) => accumulator + currentValue.cardlog.hours_spent,
        0
      ),
    [worklogs]
  );

  useEffect(() => {
    dispatch(setWorkHours(totalWorkHours));
  }, [dispatch, totalWorkHours]);

  useEffect(() => {
    const storedDate = searchParams.get("date");
    const dateValue = storedDate
      ? JSON.parse(storedDate)
      : JSON.parse(decodeURIComponent(getLastSevenDays()));

    if (!storedDate) {
      updateSearchParams("date", JSON.stringify(dateValue));
    }

    dispatch(
      setDateRange({
        endDate: new Date(dateValue.endDate),
        key: "selection",
        startDate: new Date(dateValue.startDate),
      })
    );
  }, [dispatch, searchParams, updateSearchParams]);

  const handleByTaskToggle = useCallback(() => {
    setByTask((previousValue) => !previousValue);
  }, []);

  return {
    byTask,
    cardData,
    handleByTaskToggle,
    isLoading,
    totalWorkHours,
    worklogs,
  };
}
